import LangSelect from './LangSelect';

export default LangSelect;
